import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
// material-ui
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";

// project imports
import { styled, useTheme } from "@mui/material";
import Header from "./Header";
import DisconnectedConnectionAlert from "components/DisconnectedConnectionAlert";
import UpgradeAlert from "components/Upgrade/UpgradeAlert";
import CrispChat from "components/CrispChat";
import { selectPreferences } from "store/PreferenceSlice";
import {
  getBackgroundColor,
  isValidColorName,
  isHexColor,
} from "services/backgroundColors";
import { getBackgroundImageByKey } from "constants/backgrounds";

const Main = styled("main")(({ theme, backgroundType, backgroundValue }) => {
  const baseStyles = {
    ...theme.custom.componentStyles.mainContent,
  };

  if (backgroundType === "image" && backgroundValue) {
    const image = getBackgroundImageByKey(backgroundValue);
    const imageUrl = image?.path;
    if (imageUrl) {
      return {
        ...baseStyles,
        backgroundImage: `url('${imageUrl}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      };
    }
  } else if (backgroundType === "color" && backgroundValue) {
    // Resolve color name to hex value based on theme mode
    let backgroundColor = backgroundValue;

    if (isValidColorName(backgroundValue)) {
      // It's a color name, resolve it based on theme mode
      backgroundColor = getBackgroundColor(backgroundValue, theme.palette.mode);
    } else if (isHexColor(backgroundValue)) {
      // Legacy hex color - use as is (backward compatibility)
      backgroundColor = backgroundValue;
    }

    return {
      ...baseStyles,
      backgroundColor: backgroundColor || theme.palette.background.default,
    };
  }

  // Default fallback - white background
  return {
    ...baseStyles,
    backgroundColor: theme.palette.background.default,
  };
});

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const preferences = useSelector(selectPreferences);

  const backgroundType = preferences?.backgroundType || "color";
  const backgroundValue = preferences?.backgroundValue || "white";

  return (
    <Box sx={{ bgcolor: theme.palette.background.default }} id="main-layout">
      {/* header */}
      <AppBar
        enableColorOnDark
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{
          bgcolor: theme.palette.background.default,
          borderBottom: `2px solid ${theme.palette.divider}`,
          boxShadow:
            theme.palette.mode === "dark"
              ? "0px 4px 20px rgba(0, 0, 0, 0.3)"
              : "0px 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Toolbar>
          <Header />
        </Toolbar>
      </AppBar>

      {/* main content */}
      <Main backgroundType={backgroundType} backgroundValue={backgroundValue}>
        {/* <UpgradeAlert /> */}
        <DisconnectedConnectionAlert />
        <CrispChat />
        <Outlet />
      </Main>
    </Box>
  );
};

export default MainLayout;
